export default "__VITE_ASSET__Br5OD2rB__"